<template>
    <b-container fluid>
      <PortalNavbar show="true"></PortalNavbar>

      <LoginNewHome></LoginNewHome>

      <vue-flux class="slider"
          :options="fluxOptions"
          :images="fluxImages"
          :transitions="fluxTransitions"
          ref="slider">
          <flux-pagination slot="pagination"></flux-pagination>
      </vue-flux>     
      <!-- <photos></photos>      -->

      <!-- <section class="about_us_area row">
        <div class="container" style="">
            <div class="row about_row">
                <div class="who_we_area col-lg-6 offset-lg-1 col-md-6">
                  <div class="">
                      <h2>आमच्या विषयी</h2>
                  </div>
                  <p>
                    १) महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ मर्यादित, हे महाराष्ट्र शासनाच्या सामाजिक न्याय व विशेष सहाय्य विभागाच्या अधिनस्त असलेले महामंडळ, महाराष्ट्र शासनाच्या सामान्य प्रशासन विभाग अधिसूचना (असाधारण क्रमांक २४) दि. १० मार्च, २०१७ अन्वये विमुक्त जाती, भटक्या जमाती, इतर मागासवर्ग आणि विशेष मागास प्रवर्ग कल्याण विभाग, या विभागाकडे वर्ग करण्यात आले आहे.
                  </p>
                  <p>
                    २) विमुक्त जाती, भटक्या जमाती, इतर मागासवर्ग आणि विशेष मागासप्रवर्ग कल्याण विभागाचे नाव शासन निर्णय क्रमांक इमाव 2016/प्र.क्र.95/आस्थापना, दि.24 जुलै, 2019 नुसार इतर मागासवर्ग सामाजिक व शैक्षणिक मागास प्रवर्ग, विमुक्त जाती भटक्या जमाती आणि विशेष मागास प्रवर्ग कल्याण विभाग असे करण्यात आले आहे.
                    <a href="/#/about" class="read-more-btn">Read More</a>
                  </p>
                </div>
                <div class="col-lg-4 widget_area col-md-6">
                    
                    <img src="../assets/images/guard.jpg" class="img-responsive about-us-inner-img" style="">
                </div>
            </div>
        </div>
      </section> -->
      
      <section class="our_feature_area">
        <div class="container">
            <!--<div class="tittle wow fadeInUp">
                <h2>Our Features</h2>
                <h4>Lorem Ipsum is simply dummy text of the printing and typesetting industry</h4>
            </div>-->


          <!-- new row starts -->
            <div class="row">
                <div class="col-sm-6 col-6">
                  <div class="feature-wrap">
<i class="fa fa-desktop" aria-hidden="true"></i>
 <a href="http://www.msobcfdc.org/contacUs" target="_blank">Online Grievances</a>
                  </div> <!-- feature-wrap ends -->
                </div>
                <div class="col-sm-6 col-6">
                  <div class="feature-wrap">
<i class="fa fa-check" aria-hidden="true"></i>
 <a href="http://www.msobcfdc.org/data/RTI2016.pdf" target="_blank">Right to Information</a>
          </div> <!-- feature-wrap ends -->
                </div>
                <!-- <div class="col-sm-4 col-6 offset-3 offset-sm-0">
                  <div class="feature-wrap">
                   <i class="fa fa-gavel" aria-hidden="true"></i>
                   <a href="https://mahakamgar.maharashtra.gov.in/tenders.htm">Tender & Notices</a>
                  </div> 
                </div> -->
            </div>
          <!-- new row ends -->

           
        </div>
    </section>
    <div class="footer-main">
      
      <b-nav class="">
        <ul class="nav nav-pills">
          <li class="nav-item">
            <a class="nav-link text-light small" href="/#/terms">Terms &amp; Conditions</a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-light small" href="/#/privacy">Privacy</a>
          </li>
        </ul>
      </b-nav>
    </div>
    </b-container>
</template>

<script>
import LoginNewHome from "@/components/LoginNewHome";
import PortalNavbar from "@/components/PortalNavbar";
import { VueFlux, FluxPagination, Transitions } from "vue-flux";
import Photos from "@/components/Portal/Photos";

import carousel from 'vue-owl-carousel'
export default {
  components: {LoginNewHome, PortalNavbar, VueFlux, FluxPagination,carousel,Photos },
  data() {
    return {
      fluxOptions: {
        autoplay: true,
        barWidth: 300
      
        

      },

      

      
      fluxImages: [
        require("@/assets/images/slider-1.jpg"),
        require("@/assets/images/slider-2.jpg"),
        require("@/assets/images/slider-3.jpg"),
      
      ],

    


      fluxTransitions: {
        transitionWaterfall: Transitions.transitionWaterfall,
        transitionZip: Transitions.transitionZip,
        transitionBlocks2: Transitions.transitionBlocks2
      }
    };
  },
  mounted(){
    this.$ua.trackView('Home');
  }
};
</script>

<style scoped>
.container{
    width:100% !important;
    overflow:hidden; /* Fixing Horizontal scrollbar overflow break */
}

.container-fluid{
  overflow:hidden;
}
.panel-heading {
  padding: 18px 15px;
}
.media {
  border-bottom: none;
  font-size: 14px;
  font-family: "Open sans", sans-serif;
  line-height: 1.42857143;
  color: #333;
  padding-bottom: 10px;
  padding-top: 15px;
}
.marquee {
  top: 6em;
  position: relative;
  box-sizing: border-box;
  animation: marquee 15s linear infinite;
}

.media-heading {
  margin-top: 0;
  margin-bottom: 5px;
}

.h4,
h4 {
  font-size: 18px;
}

.marquee:hover {
  animation-play-state: paused;
}

/* Make it move! */
@keyframes marquee {
  0% {
    top: 8em;
  }
  100% {
    top: -11em;
  }
}

.header_aera .navbar-collapse .navbar-nav.navbar-right li a {
  margin-top: -15px;
}

.panel-info-crc {
  border-color: #c90c5c;
}

.panel-info-crc > .panel-heading {
  color: #fefefe;
  background-color: #c90c5c;
  border-color: #c90c5c;
}

.panel-info-crc2 {
  border-color: #dc6800;
}

.panel-info-crc2 .panel-heading {
  color: #fefefe;
  background-color: #dc6800;
  border-color: #c90c5c;
}

.panel-primary .panel-heading {
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
}

.list-group {
  padding-left: 0;
  margin-bottom: 20px;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
  font-family: "Open sans", sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
}

.media-body,
.media-left,
.media-right {
  display: table-cell;
  vertical-align: top;
}

.media-body {
  width: 10000px;
}
.media,
.media-body {
  overflow: hidden;
  zoom: 1;
}


.slider{
  height: 300px;;
}


.about_us_area{
  font-family: 'Laila', serif;
}

.about_us_area .about_row p{
  font-family:'Laila', serif;
  color:#333;
  font-weight: 400;
  font-size: 15px;
  line-height: 1.5;
  padding-top:15px;
  padding-bottom:0;
}

.about_us_area .about_row h2{
  color:#333;
}

.about-us-inner-img{

  width:100%;
  border-radius: 7px;
  border:1px solid #d3d3d3;
  
}

.read-more-btn{
  font-family: 'Open Sans', sans-serif;
  color:#fff;
  background:#2e4b90;
  font-size:13px;
  font-weight:bold;
  display: block;
  padding:7px 20px;
  width: fit-content;
  border-radius: 4px;
  margin-top:5px;
}

@media(max-width: 1199px){
  .slider{
  height: 250px;;
}
}

@media(max-width:991px){
  .slider{
    height: 200px;
  }
}

.our_feature_area{
  padding-top:30px;
  padding-bottom: 30px;
  background-color: #f1f1f1;
  
}

@media(max-width: 767px){
  .about-us-inner-img{
    margin-top:0;
  }

  .about_us_area .about_row p{
    padding-bottom: 0;
  }

  .our_feature_area{
  padding-top:25px;
  padding-bottom:25px;
}
  .our_feature_area .feature-wrap{
    padding:15px;
  }
}


/* Out feature changes */



.our_feature_area .feature-wrap{
  width:fit-content;
  margin:auto;
  display:flex;
  align-items: center;
}

.our_feature_area .feature-wrap i{
  padding:20px;
  background:#2e4b90;
  color:#fff;
  border-radius: 50%;
  margin-right: 10px;

}

.our_feature_area .feature-wrap a{
  color:#000;
  font-weight: bold;
  font-size: 14px;
  
}



@media(max-width: 575px){
    .our_feature_area{
      padding-right: 10px;
      padding-left: 10px;
      padding-top:10px;
      padding-bottom:10px;
    }
  .our_feature_area .feature-wrap{
    margin-top:10px;
    margin-bottom:10px;
  }

   .our_feature_area .feature-wrap a{
    font-size:13px;
  }

  .our_feature_area .feature-wrap i{
    padding:15px;
  }
}

@media(max-width:419px){
  .our_feature_area .feature-wrap{
    padding-left:0;
    padding-right:0;
  }
}

.our_feature_area .feature-wrap a{
  font-size:12px;
}

.our_feature_area .feature-wrap i{
  padding:10px;
}



</style>



// WEBPACK FOOTER //
// src/components/Home.vue